(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-redimi"] && !Shopify.designMode) return;
  try {
    

  function initializeRedimiProduct(section) {

    if (!section || section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';



    const mainImage = section.querySelector('.redimi-product__main-image');

    const thumbnails = section.querySelectorAll('[data-thumbnail]');

    const variantSelect = section.querySelector('[data-variant-select]');

    const price = section.querySelector('[data-price]');

    const comparePrice = section.querySelector('[data-compare-price]');

    const discount = section.querySelector('[data-discount]');

    const addButton = section.querySelector('[data-add-button]');

    const quantityInput = section.querySelector('[data-quantity-input]');

    const minusButton = section.querySelector('[data-quantity-minus]');

    const plusButton = section.querySelector('[data-quantity-plus]');



    function setMainImage(url, alt) {

      if (!mainImage || !url) return;

      mainImage.style.opacity = '0';

      mainImage.src = url;

      mainImage.srcset = '';

      mainImage.alt = alt || '';

      requestAnimationFrame(() => { mainImage.style.opacity = '1'; });

    }



    thumbnails.forEach((thumbnail) => {

      thumbnail.addEventListener('click', () => {

        setMainImage(thumbnail.dataset.imageUrl, thumbnail.dataset.imageAlt);

        thumbnails.forEach((item) => {

          item.classList.remove('is-active');

          item.setAttribute('aria-pressed', 'false');

        });

        thumbnail.classList.add('is-active');

        thumbnail.setAttribute('aria-pressed', 'true');

      });

    });



    if (variantSelect) {

      variantSelect.addEventListener('change', () => {

        const option = variantSelect.options[variantSelect.selectedIndex];

        const available = option.dataset.available === 'true';

        const compareValue = option.dataset.comparePrice;

        const discountValue = option.dataset.discount;



        if (price) price.textContent = option.dataset.price;

        if (comparePrice) {

          comparePrice.textContent = compareValue || '';

          comparePrice.classList.toggle('is-hidden', !compareValue);

        }

        if (discount) {

          discount.textContent = compareValue ? `SAVE ${discountValue}%` : '';

          discount.classList.toggle('is-hidden', !compareValue);

        }

        if (addButton) {

          addButton.disabled = !available;

          addButton.textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldOutLabel;

        }

        setMainImage(option.dataset.imageUrl, option.dataset.imageAlt);

      });

    }



    if (minusButton && quantityInput) {

      minusButton.addEventListener('click', () => {

        quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);

      });

    }



    if (plusButton && quantityInput) {

      plusButton.addEventListener('click', () => {

        quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);

      });

    }

  }



  document.querySelectorAll('[data-redimi-product]').forEach(initializeRedimiProduct);

  document.addEventListener('shopify:section:load', (event) => {

    initializeRedimiProduct(event.target.querySelector('[data-redimi-product]'));

  });


  } catch(e) { console.error(e); }
})();
})();
